export const TITLE_MY_PROFILE = 'My Profile';
export const TITLE_UPLOAD_PHOTO = 'Upload Photo';
export const PHOTO_EDIT_INSTRUCTION =
   'Drag the photo to centre your head and shoulders within the frame';
export const SAVE_MESSAGE =
   'Thanks for uploading a new profile picture. Once it has been approved by our licensing staff in the next couple of working days, this picture will be active in your profile and will be used for your licence card. We will be in touch if there are any issues.';
export const PREVIEW_EXAMPLE = 'Here’s an example of a Licence photo';
export const DEFAULT_PHOTO_PATH = '/images/default-profile-photo.png';
